import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { CaricamentoService } from '@services/caricamento.service';
import { NavigazioneService } from '@services/navigazione.service';
import { BackToTopComponent } from '@shared/back-to-top/back-to-top.component';
import { LoaderComponent } from '@shared/loader/loader.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { TopbarComponent } from '../topbar/topbar.component';

@Component({
  selector: 'app-main',
  standalone: true,
  imports: [RouterOutlet, LoaderComponent, BackToTopComponent, SidebarComponent, TopbarComponent],
  templateUrl: './main.component.html',
})
export class MainComponent {
  readonly authService = inject(AuthService);
  readonly navigazione = inject(NavigazioneService);
  readonly caricamento = inject(CaricamentoService);

  constructor() {
    this.initializeApp();
    this.authService.checkAuth()?.subscribe();
  }

  initializeApp() {
    if (window.location.pathname.includes('/be/auth')) {
      window.open(window.location.href, '_self');
    }
    if (window.location.search.includes('?')) {
      const url = new URL(window.location.href);
      if (url.searchParams.get('token') !== null) {
        this.authService.token = url.searchParams.get('token') || '';
        window.location.href = '/';
      }
    }
  }
}
